export default "__VITE_ASSET__LafW6hPU__"